import { render, staticRenderFns } from "./ManagerSupportReferral.vue?vue&type=template&id=b455437a"
import script from "./ManagerSupportReferral.vue?vue&type=script&lang=js"
export * from "./ManagerSupportReferral.vue?vue&type=script&lang=js"
import style0 from "./ManagerSupportReferral.vue?vue&type=style&index=0&id=b455437a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports